import { render, staticRenderFns } from "./DialogCustomerEdit.vue?vue&type=template&id=5c4436a1&scoped=true"
import script from "./DialogCustomerEdit.vue?vue&type=script&lang=js"
export * from "./DialogCustomerEdit.vue?vue&type=script&lang=js"
import style0 from "./DialogCustomerEdit.vue?vue&type=style&index=0&id=5c4436a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4436a1",
  null
  
)

export default component.exports